export default __webpack_public_path__ + "static/media/loader_xdai.7dbfafba.gif";